import GlobalModal from '../components/atoms/GlobalModal'
import { FlashMessage } from '../components/organisms'

export interface IWindow extends Window {
  open: any
  google: any
  location: any
  navigator: any
  globalModal: GlobalModal
  flashMessages: FlashMessage
  onpopstate: any
  confirm: any
  history: any
  dataLayer: any
  rewardful: any
  Rewardful: any
}

export interface IErrors {
  [key: string]: string | null
}

export interface IPager {
  current_page: number
  next_page: null | number
  prev_page: null | number
  total_count: number
  total_pages: number
}

export interface IUser {
  admin: boolean
  agent: boolean
  avatar_attached: boolean
  avatar_url: string
  avatar_middle_url?: string
  avatar_large_url?: string
  areas?: IMasterItem[]
  catchphrase: string
  cover_url: string
  bio: string
  created_at: string
  email: string
  fullname: string
  guest: boolean
  guide: boolean
  id: number
  identification_workflow_state?: null | string
  posts_count: number
  review_count?: number
  social_profiles?: string[]
  stripe_customer_id: null | string
  joined_date: string
  unread_notifications_count: number
  updated_at: string
  username: string
  country_code: string
  guide_approved?: boolean
  user_detail?: IUserDetail
  non_member?: boolean
}
export interface IUserDetail {
  display_language: IDisplayLanguage
  display_language_id: number
  created_at: string
  id: number
  bio: string | null
  catchphrase: string | null
  updated_at: string
}
export interface IPostImage {
  created_at: string
  description: null | string
  id: number
  image_url: string
  large_url?: string
  middle_url?: string
  thumb_url?: string
  position: number
  updated_at: string
}

type PartialUser = Partial<IUser>

export interface IMeetingPoint {
  id: number
  location: string
  name: string
  memo: string
  latitude: string
  longitude: string
}

export interface IPostVideo {
  id: number
  name: string
  description: string
  youtube_video_id: string
  position: number
  media: string
  image_url: string
  thumb_url: string
}

export interface IDisplayLanguage {
  code: string
  id: number
  name: string
  name_i18n: string
  name_ja: string
  position: number
}

/**
 * ツアーの予約開始時間に関連するオブジェクト。特筆すべきプロパティは以下
 * @property available_count プライベートの場合は空き枠数、グループの場合は空き人数
 * @property limit_people プライベートの場合は最大予約可能人数、グループの場合は空き人数か最大予約可能人数で小さい方
 * @property reserved プライベートの場合は空き枠数が埋まっているか、グループの場合は空き人数が埋まっているか
 * @interface
 */
export interface IStartTime {
  post_id: number
  start_time: string
  available_count: number
  limit_people: number
  reserved: boolean
  post_start_time_id: null | number
  post_calendar_id: null | number
}

export type IIncludedCategory = 'food' | 'drinks' | 'tickets' | 'transportation' | 'equipment'

export interface IIncludedItem {
  type: IIncludedCategory
  description: string
}

export interface IPostDetail {
  display_language: IDisplayLanguage
  display_language_id: number
  cancel_policy: string | null
  created_at: string
  highlight: string | null
  id: number
  name: string | null
  included: string | null
  itinerary: string | null
  not_included: string | null
  ogp_description: string | null
  overview: string | null
  post_id: number
  remarks: string | null
  updated_at: string
  food: string | null
  drinks: string | null
  tickets: string | null
  transportation: string | null
  equipment: string | null
  included_items: IIncludedItem[]
}

export interface IPost {
  aasm_state_i18n: string
  average_review_score: number
  category_id?: number
  category?: {
    id: number
    name: string
    position: number
  }
  area_id?: number
  city: string
  created_at: string
  description?: string
  full_address: string
  family_owner: boolean
  family_owner_slug?: string | null
  id: number
  latitude: number
  longitude: number
  name: string
  note: string
  post_image?: IPostImage
  post_images?: IPostImage[]
  post_prices?: any[]
  limit_participant_type?: 'child' | 'infant' | null
  price: string
  public_address: string
  published_at: null | string
  published: boolean
  slug: string
  state: string
  street1: null | string
  street2: null | string
  tags: any[]
  languages: any[]
  user: PartialUser
  user_liked: boolean
  viewed_count: number
  zipcode: null | string
  ogp_description?: string
  post_type: string
  itinerary: string
  overview: string
  included: string
  not_included: string
  remarks: string
  duration: string
  max_people: string
  booking_max_people?: number
  min_people: string
  tour_group_max_attendees?: number
  meeting_points?: IMeetingPoint[]
  cutoff_times: string
  highlight: string
  cancel_policy: string
  pickup: boolean
  allow_pickup?: boolean
  post_start_times?: IPostStartTimes[]
  post_calendars?: any[]
  post_detail?: IPostDetail
  post_details?: IPostDetail[]
  instant_booking: boolean
  bokun_activity_id?: string
  bokun_product_code?: string
  short_name?: string
  expandable?: boolean
  alert_remaining_number?: number
  alert_number?: number
  cancel_policy_id?: number
  post_tour_skill?: IPostTourSkill
  post_cost?: IPostCost
  guide_meeting_time_offset?: number | null
}

export interface IMemberPost {
  aasm_state: string
  aasm_state_i18n: string
  alert_number: number | null
  alert_remaining_number: number
  area_id: number
  average_review_score: number
  bokun_activity_id: string | null
  cancel_policy_id: string | null
  category: any
  city: string | null
  created_at: string
  cutoff_times: number
  duration: number
  expandable: boolean
  family_owner: boolean
  full_address: string
  id: number
  instant: string
  instant_booking: boolean
  is_owner: boolean
  latitude: number | null
  likes_count: number
  longitude: number | null
  max_people: number
  booking_max_people?: number
  meeting_points: any
  min_people: number
  name: string
  note: string | null
  pickup: boolean
  allow_pickup?: boolean
  post_detail: {
    cancel_policy: string | null
    created_at: string | null
    display_language_id: number
    highlight: string | null
    id: number
    included: string | null
    itinerary: string | null
    name: string | null
    not_included: string | null
    ogp_description: string | null
    overview: string | null
    post_id: number
    remarks: string | null
    updated_at: string
  }
  post_prices: any
  post_start_times: any
  post_type: string
  price: string
  private_quantity: number
  public_address: string
  published: boolean
  published_at: string
  review_mapping: Record<string, any>
  reviews_count: number
  short_name: string
  slug: string
  state: string | null
  street1: string | null
  street2: string | null
  tour_group_max_attendees: number
  updated_at: string
  user: any
  user_id: number
  zipcode: string | null
}

export interface IPostStartTimes {
  created_at: string
  days: number[]
  end_date: string
  id: number
  max_people: number
  post: any
  start_date: string
  start_time: string
  updated_at: string
}
export interface IAgentPost {
  family_owner: boolean
  id: number
  name: string
  short_name: string
}

export interface ICustomPost extends IPost {
  size: string
  capacity: string
  functionality: string
  areas: null | number
  private_quantity?: number
  booking_max_people?: number
  tour_group_max_attendees?: number
  cancel_policy_id?: number
  bokun_activity_title?: string
  bokun_activity?: {
    id: number
    activity_id: string
    title: string
    product_code?: string
    max_per_booking?: number
    last_updated_at: string
    created_at: string
    updated_at: string
  }
}

/**
 * `sessionStorage['reservationStorageData']` に保存する予約導線の画面間状態。
 *
 * JSON として保存するため、日付は `moment.Moment` ではなく文字列になる。
 * 予約導線の開始地点・遷移段階によって格納される値が異なるため、すべての
 * プロパティは存在を保証しない。特に `memberPost` がない場合は、支払い画面と
 * 完了画面が予約導線を中断してツアー詳細へリダイレクトする。
 */
export interface IReservationStorageData {
  /**
   * 保存済みデータのスキーマバージョン。ヘルパー経由で保存されたv1以降の値には常に入る。
   * バージョン情報がない既存データは、読み込み時にv1として扱い、`version: 1` を補完する。
   */
  version?: 1

  /**
   * 予約導線中の最新の日付・参加人数。URL パラメーターとCookieより優先して使う。
   */
  initParams?: IReservationStorageInitParams

  /** 支払い・完了画面で表示する、選択済みの参加人数。 */
  guests?: IReservationStorageGuests

  /**
   * 選択した料金・参加条件を含むツアー情報。
   */
  memberPost?: ICustomPost

  /** 支払い・完了画面で使う、選択済みの日程・開始時刻・表示価格。 */
  reservation?: IReservationStorageSelection

  /** クーポン適用後の請求金額。予約完了後に結果画面へ引き渡す。 */
  chargePrice?: number

  /** クーポンが適用された、または予約作成結果にクーポン名がある場合に `true`。 */
  hasCoupon?: boolean

  /**
   * 予約作成 API のレスポンス。レスポンス形状は現状このストレージでは固定していない。
   */
  createdReservation?: any
}

/** `reservationStorageData.initParams` の値。 */
export interface IReservationStorageInitParams {
  /**
   * 選択日。保存元により `YYYY-MM-DD` または ISO 8601 形式の文字列になる。
   */
  dates?: string[]

  /** 検索・日付選択画面で使う参加人数。 */
  guests?: IReservationStorageGuests
}

/** 予約導線内で使う参加人数。 */
export interface IReservationStorageGuests {
  adults: number
  children: number
  infants: number
}

/** `reservationStorageData.reservation` の、日程選択後に保存される値。 */
export interface IReservationStorageSelection {
  /** 選択日。JSON 保存後は ISO 8601 形式の文字列。 */
  selectedDate?: string

  /** 選択時点の合計表示価格。選択前は `null` になり得る。 */
  totalPrice?: number | null

  /** 選択した開始時刻・在庫情報。開始時刻未選択時は `null` になり得る。 */
  departure?: IStartTime | null
}

export interface IDayEventsObject {
  reservations: any[]
  direct_reservations: any[]
  soundouted?: boolean
  requested?: boolean
}

export interface ITag {
  id: number
  name: string
  name_ja: string
}

export interface IMasterItem {
  id: number
  name: string
  position: number
}

export interface ISales {
  rates: {
    sales: number
    reservations: string
    profile: number
    reviews: number
  }
  amount: number
  amount_last_month: number
  earning: number
  earning_last_month: number
  tour_group_earning: number
  tour_group_earning_last_month: number
}

export interface IReceipt {
  created_at: string
  guest_name: string
  id: number
  name: string
  no: string
  payment_amount: number
  payment_date: string
  payment_method: string
  reservation_id: number
  reservation_no: string
  tour_date: string
  tour_name: string
  updated_at: string
}

export interface IConversation {
  conversation_type: 'reservation' | 'pre_assign' | 'assign' | 'tour_group'
  id: number
  slug: string
  target_id: number
  target_type: string // "Reservation" and other
  available: boolean
}

export enum TourGuideRequestStatus {
  nothing = 'nothing',
  agent_pre_requested = 'agent_pre_requested',
  agent_pre_canceled = 'agent_pre_canceled',
  guide_approved = 'guide_approved',
  guide_declined = 'guide_declined',
  agent_official_requested = 'agent_official_requested',
  guide_canceled = 'guide_canceled',
  agent_canceled = 'agent_canceled',
  guide_applied = 'guide_applied',
  agent_rejected = 'agent_rejected',
}

export interface IReservable {
  assignment_status: 'unassigned' | 'assigned'
  conversation: IConversation
  guest_name: string | null
  id: number
  num_of_adults: number
  num_of_children: number
  num_of_infants: number
  num_of_people?: number
  price: number
  memo?: string
  slug: 'eec0b5a129b53b64'
  thanks_mail_sent_at: string | null
  thanks_mail_sent_count: number
  user: {
    avatar_url: string
    id: number
    username: string
    non_member?: boolean
  }
  workflow_state: string
  workflow_state_enum_value: 'requested' | 'approved' | 'declined' | 'canceled'
  check_in: boolean
}
export interface ITourReservation {
  id: number
  reservable: IReservable
  reservable_id: number
  reservable_type: 'Reservation' | 'DirectReservation'
  tour_group_id: number
  tour_id: number
}

export interface ITourGroupGuide {
  avatar_url: string
  id: number
  username: string
}
export interface ITourGroup {
  guide?: ITourGroupGuide
  id: number
  tour_id: number
  tour_reservations: ITourReservation[]
  conversation: IConversation
  guide_report: IGuideReport
  reimbursable_cost: number
  subcontract_cost: number
  tour_cost: number
  memo: string
}

export interface ITourGroupPost {
  id: number
  name: string
  is_owner: boolean
  post_image: IPostImage
  user_id: number
  user: IUser
  slug: string
  tour_group_max_attendees?: number
  booking_max_people?: number
  post_type: string
  private_quantity?: number
  bokun_activity_id?: string
  max_people?: number
}
export interface ITours {
  created_at: string
  day: string
  id: number
  post: ITourGroupPost
  post_id: number
  start_time: string
  start_at?: string
  tour_groups: ITourGroup[]
  unassigned_tour_reservations: ITourReservation[]
  tour_reservations?: ITourReservation[]
  tour_guides?: ITourGuide[]
}
export interface IGuideReport {
  id: number
  reportable_type: string
  reportable_id: number
  status: string
  additional_cost: number
  additional_service: string
  bad_point: string
  created_at: string
  difficult_point: string
  good_point: string
  num_of_people: number
  other: string
  updated_at: string
  user_id: number

  reportable: {
    id: number
    reimbursable_cost: number
    subcontract_cost: number
    tour_cost: number
    memo: string
    tour_id: number
    updated_at: string
    created_at: string
  }
}

export interface IReview {
  body: string
  id: number
  rating: number
  is_open?: boolean
  rating_friendliness: number
  rating_hospitality: number
  rating_informative: number
  rating_involved: number
  rating_language: number
  rating_passion: number
  reservation: any
  review_reply: any
  reviewer?: any
  direct_reservation?: any
  reviewer_name?: any
  review_date?: any
  reviewable?: IPost
  reviewable_type?: string
  reviewable_id?: number
  anonymous_review_author?: string
  review_image_urls?: string[]
  review_image?: {
    id: number
    image_url?: string
    thumb_url?: string
    large_url?: string
    is_open?: boolean
  }
}

export interface IFormalRequestTemplate {
  id: number
  title: string
  mail_subject: string
  mail_text: string
  agent_id: number
  agent_rank_id: number | null
  default_post_ids?: number[]
  posts: Array<{
    id: number
    name: string
    short_name: string
  }>
}

export interface ISoundOutTemplate {
  id: number
  title: string
  message: string
  agent_id: number
  mail_subject: string
  agent_rank_id: number | null
  default_post_ids?: number[]
  posts: Array<{
    id: number
    name: string
    short_name: string
  }>
}

export interface ITourMemoTemplatePost {
  id: number
  tour_memo_template_id: number
  post_id: number
  is_default: boolean
}

export interface ITourMemoTemplate {
  id: number
  title: string
  message: string
  agent_id: number
  is_default: boolean
  posts: Array<{
    id: number
    name: string
    short_name: string
  }>
}

export interface IMessage {
  body: string
  conversationId: number
  conversation: IConversation
  created_at: string
  file_attached: boolean
  file_url: null | string
  formatted_sent_time: string
  id: number
  sender: IUser
  sent_at: string
  updated_at: string
  other?: boolean
  tour_guide?: ITourGuide
  tour_guide_message?: ITourGuideMessage
  isSelf?: boolean
}

export interface ITourGuideMessage {
  message?: IMessage
  created_at: string
  tour_guide_id: number
  id: number
  status: 'agent_official_requested' | 'guide_approved' | 'guide_declined'
  message_id: number
  updated_at: string
}
export interface ITourGuide {
  created_at: string
  guide_id: number
  id: number
  request_status: TourGuideRequestStatus
  request_status_i18n: string
  tour_group_id: number | null
  tour_id: number
  tour_guide_messages?: ITourGuideMessage[]
  tour?: ITours
  guide?: IUser
  updated_at: string
}

export interface IFeaturePostImage {
  id: number
  position: number
  description: string
  image_url: string
  large_url: string
  thumb_url: string
  created_at: string
  updated_at: string
}

export interface IFeaturePost {
  id: number
  user_id: number
  slug: string
  aasm_state: string
  cutoff_times: number
  max_people: number
  min_people: number
  aasm_state_i18n: string
  published: boolean
  latitude: number | null
  longitude: number | null
  likes_count: number
  reviews_count: number
  average_review_score: number
  public_address: string
  full_address: string
  note: string | null
  instant: string
  zipcode: string | null
  state: string | null
  city: string | null
  street1: string | null
  street2: string | null
  duration: number
  post_type: string
  pickup: boolean
  allow_pickup?: boolean
  area_id: number
  alert_number: number | null
  family_owner: boolean
  price: string
  user_liked: boolean | null
  name: string
  created_at: string
  updated_at: string
  published_at: string
  is_owner: boolean
  post_image: IFeaturePostImage
}

export interface IFeature {
  id: number
  slug: string
  title: string
  description: string
  detail_title: string
  detail_description: string
  position: number
  area_ids: number[]
  category_ids: number[]
  tag_ids: number[]
  created_at: string
  updated_at: string
}

export interface IMessageReservation {
  id: number
  slug: string
  receipt_accessible: false
  num_of_adults: number
  num_of_children: number
  num_of_infants: number
  cancel_reason: null
  assignment_status: string
  no: string
  initial_message: null
  host_cancel_reason: null
  cancellation_requested_by_guest: null
  canceled_by: null
  other_requests: string
  pickup_location: null
  pickup_latitude: null
  pickup_longitude: null
  next_work_flow_state: null
  is_past: false
  guest_cancelled_fee: 0
  tour_date: string
  workflow_state: string
  workflow_state_enum_value: 'requested' | 'approved' | 'declined' | 'canceled'
  created_at: string
  price: string
  charge_price: string
  start_at: string
  end_at: string
  guest_name: string
  guest_email: string
  post: IPost
}

export interface IReservation {
  id: number
  slug: string
  num_of_adults: number
  num_of_children: number
  num_of_infants: number
  cancel_reason: null
  assignment_status: string
  no: string
  initial_message: null
  host_cancel_reason: null
  cancellation_requested_by_guest: null
  canceled_by: null
  other_requests: string
  pickup_location: null
  pickup_latitude: null
  pickup_longitude: null
  pickup_memo?: string | null
  next_work_flow_state: null
  is_past: false
  guest_cancelled_fee: 0
  tour_date: string
  workflow_state: string
  workflow_state_enum_value: 'requested' | 'approved' | 'declined' | 'canceled'
  created_at: string
  price: string
  charge_price: string
  start_at: string
  end_at: string
  guest_name: string
  guest_email: string
  post: IPost
  user_id: string
  conversation?: IConversation
}

export interface IAssignGuideTourSkill {
  tour_skill_id: string
  level: string | null
  condition_type?: string
}

export interface IAssignGuideRangeTourSkill {
  tour_skill_id: string
  min_level: number
  max_level: number
}

interface IGuideFilterOptionsBase {
  name: string
  email: string
  tel: string
  ages: number[]
  gender: string
  tour_guide_count_min: number | null
  tour_guide_count_max: number | null
  agent_skills: number[]
  agent_ranks?: number[]
  statuses: Array<'active' | 'inactive' | 'deleted'>
  login_status: '' | 'never_logged_in' | 'logged_in'
}

export interface IGuideFilterOptions extends IGuideFilterOptionsBase {
  assign_guide_tour_skills: IAssignGuideTourSkill[]
}

export interface IGuideFilterOptionsWithRangeSkills extends IGuideFilterOptionsBase {
  post_id?: number
  day?: string
  start_time?: string
  assign_guide_tour_skills: IAssignGuideRangeTourSkill[]
}

export interface ITourGuideByAssignmentsParam {
  guide_id: string
  month: string
  post_type?: string | null
  request_statuses: string[]
}

export interface IPostTourSkill {
  id: number
  post_id: number
  tour_skill_id: number
  level?: number | null
}

export interface IAgentSkill {
  id: number
  name: string
  name_en?: string
  name_ja?: string
  position: number
  agent_id: number
}

export interface IAgentTourSkill {
  id: number
  name: string
  name_en?: string
  name_ja?: string
  position: number
  agent_id: number
  assigned_guide_count?: number
}

export interface IGuideTourSkillBulkAssignmentGuide {
  id: number
  fullname: string | null
  username: string | null
  email: string
  already_assigned: boolean
  assigned_level: number | null
}

export interface IGuideTourSkillBulkAssignmentPreview {
  matched: Array<{
    input: string
    type: 'id' | 'email' | 'name'
    guide: IGuideTourSkillBulkAssignmentGuide
  }>
  ambiguous: Array<{
    input: string
    type: 'id' | 'email' | 'name'
    candidates: IGuideTourSkillBulkAssignmentGuide[]
  }>
  not_found: Array<{
    input: string
    type: 'id' | 'email' | 'name'
  }>
  summary: {
    matched: number
    ambiguous: number
    not_found: number
  }
}

export type OtaCheckinStatus = 'not_yet' | 'checked_in' | 'no_show'

export interface IOtaReservation {
  id: number
  uuid: string

  jwt_reservation_id: number | null
  jwt_post_id: number | null
  jwt_tour_id: number | null
  jwt_tour_group_id: number | null

  channel_manager: string
  seller: string

  seller_booking_id: string | null
  seller_booking_created_at: string

  channel_manager_booking_id: string | null
  channel_manager_confirmation_code: string | null
  channel_manager_product_confirmation_code_list: string | null

  booking_status_id: 'confirmed' | 'canceled' | 'pending' | 'declined'
  payment_status_id: 'free' | 'paid' | 'invoiced' | 'deposit' | 'unpaid'

  customer_email: string | null
  customer_first_name: string | null
  customer_last_name: string | null
  customer_full_name: string | null
  customer_phone: string | null
  customer_country: string | null

  custom_booker_name: string | null
  custom_guest_name: string | null

  num_of_adults: number
  num_of_children: number
  num_of_infants: number
  num_of_people: number

  currency: string
  total_price: number

  tour_product_id: string
  tour_title: string
  tour_name: string

  tour_date: string
  start_at: string
  end_at: string

  checkin_status: OtaCheckinStatus

  pickup_location: string | null
  pickup_memo?: string | null
  pickup_latitude: string | null
  pickup_longitude: string | null

  meeting_point_id: number | null

  other_requests: string | null
  memo: string | null
  internal_memo: string | null

  canceled_at: string | null
  cancel_reason: string | null

  refund_amount: number | null
  payment_process_cost: number | null
  system_cost: number | null

  meetup_place_id: number | null
  meetup_place: IMeetupPlace | null
  custom_meetup_point: string | null
  custom_meetup_point_url: string | null

  tour_start_at: string

  manual_time_override?: boolean

  created_at: string
  updated_at: string

  is_past: boolean

  reservation?: IReservation
  post?: IPost | null
}

export interface IGuestEmail {
  id: number
  ota_reservation_id: number
  email: string
  created_at: string
  updated_at: string
}

export interface IMeetupPlace {
  id: number | null
  name_ja: string | null
  name_en: string | null
  area: string | null
  sub_area: string | null
  meetup_point: string | null
  meetup_point_url: string | null
}

export interface IPartnerVenuePost {
  id: number
  short_name: string
}

export interface IPartnerVenue {
  id: number
  name: string
  slug: string
  login_id: string
  is_active: boolean
  is_guest_list_active: boolean
  posts: IPartnerVenuePost[]
}

export interface IPostCost {
  id: number
  post_id: number
  default_travel_cost: number
  unit_cost: number
  other_total_cost: number
  special_activity_fee_1: number
  special_activity_fee_2: number
  special_activity_fee_3: number
  special_activity_fee_4: number
  special_activity_fee_5: number
  special_activity_fee_6: number
  special_activity_fee_7: number
  special_activity_fee_8: number
  special_activity_fee_9: number
  special_activity_fee_over_base: number
  special_activity_fee_over_unit: number
  large_group_min_people: number
  large_group_fee: number
}

export interface ILanguage {
  id: number
  name: string
  name_ja: string
  name_en: string
  position: number
  code: string
}

export interface IVisaType {
  id: number
  name_ja: string
  name_en: string
  position: number
  is_active: boolean
  code: string
}

export interface IGuideInfo {
  id: number
  guide_id: number
  visa_type_id: number
  visa_expires_at: string
  interpreter_guide_qualification: boolean
  has_my_number: boolean
  bio: string
}

export interface IBankAccount {
  id: number
  invoice_number: string
  recipient_name: string
  is_company: boolean
  account_name: string
  account_number: string
  account_type: string
  bank_name: string
  branch_name: string
}

export interface IGuidePayment {
  id: number
  guide_id: number
  payment_due_date: string
}

export interface IPaymentDetail {
  id: number
  tour_id: number
  tour_group_id: number | null
  guide_payment_id: number
  guide_fee: number
  other_fee: number
  travel_cost: number
  deduction: number
  cancellation_fee: number
  // 人数連動手当・立替経費と合計はサーバーが読み出し時に計算し、要求した API でのみ返る
  calculated_special_activity_fee?: number
  calculated_large_group_fee?: number
  calculated_advance_cost?: number
  total?: number
  status: 'ongoing' | 'canceled'
  guide_payment: IGuidePayment
}

export interface IAgentRank {
  id: number
  name: string
  name_ja: string
  name_en: string
  position: number
  rank_kind: 'normal' | 'special'
  enabled: boolean
  is_base: boolean
}

export interface IConnectionMailTemplate {
  id: number
  title: string
  mail_subject: string
  mail_text: string
  blank_item: number
  target_user_type: number
  template_pair_id: number | null
}

export interface IJob {
  id: number
  tour_id: number
  post_id: number
  job_bulk_plan_id: number
  agent_rank_id?: number | null
  agent_rank?: IAgentRank | null
  date: string
  start_time: string
  start_at: string
  is_draft: boolean
  has_bulk_diff: boolean
  is_deleted: boolean
  publish_start_at: string
  publish_end_at: string
  job_slots: IJobSlot[]
  client_uid?: string
}

export interface IJobBulkPlan {
  id: number | undefined
  post_id: number
  agent_rank_id?: number | null
  agent_rank?: IAgentRank | null
  include_no_booking: boolean
  target_date_from: string
  target_date_to: string
  weekday_0: boolean
  weekday_1: boolean
  weekday_2: boolean
  weekday_3: boolean
  weekday_4: boolean
  weekday_5: boolean
  weekday_6: boolean
  publish_start_at: string
  publish_end_at: string
  is_deleted?: boolean
  deleted_at?: string | null
  job_bulk_plan_slots?: IJobBulkPlanSlot[]
  job_bulk_plan_start_times?: IJobBulkPlanStartTime[]
  created_at?: string
  updated_at?: string
}

export interface IJobBulkPlanStartTime {
  id: number | undefined
  job_bulk_plan_id: number | undefined
  start_time: string
}

export interface IJobSlot {
  id: number
  job_id: number
  tour_skill_id: number
  tour_skill_min_level: number
  tour_skill_max_level: number
  direct_max_limit: number
  direct_count: number
  allow_selection: boolean
  selection_max_limit: number
  skill_ids: number[]
  tour_skill: ITourSkill
  client_uid?: string
}

export interface IJobBulkPlanSlot {
  id: number
  job_bulk_plan_id: number
  tour_skill_id: number
  tour_skill_min_level: number
  tour_skill_max_level: number
  direct_max_limit: number
  direct_count: number
  allow_selection: boolean
  selection_max_limit: number
  skill_ids: number[]
  tour_skill: ITourSkill
  client_uid?: string
}

export interface ISkill {
  id: number
  name: string
}

export interface ITourSkill {
  id: number
  name: string
}

export interface ICategory {
  id: number
  name_i18n: string
  position: number
}

export interface ITag {
  id: number
  name: string
}

export interface IArea {
  id: number
  name: string
  position: number
}

export interface ICancelPolicy {
  id: number
  name: string
  position: number
}

export interface IPersonalReservationInfo {
  other_requests: string
  pickup_location: string
  pickup_latitude: string
  pickup_longitude: string
  pickup_location_selection_error?: boolean
  country_code: string
  email: string
  fullname: string
  tel: string
}
